// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_XeUWg{--rootMargin:-20px -15px 0;--rootWidth:calc(100% + 30px)}@media only screen and (min-width:768px){.root_XeUWg{--rootMargin:0;--rootWidth:100%}}.root_XeUWg{position:relative;margin:var(--rootMargin);width:var(--rootWidth)}.root_XeUWg.square_bpCMh{padding-top:calc(min(100%, 100vh) + 30px)}.content_UJwzZ{width:100%}.content_UJwzZ.absolute_J9m4n{position:absolute;top:0;left:0;right:0;bottom:0}", ""]);
// Exports
exports.locals = {
	"root": "root_XeUWg",
	"square": "square_bpCMh",
	"content": "content_UJwzZ",
	"absolute": "absolute_J9m4n"
};
module.exports = exports;
